import { styled } from '@migros/msrc-ui-kit';
export const ArticleLink = styled.a`
  display: block;
  text-decoration: none;
`;